// CoinsDoPerfil.js — a letra miúda dos coins de perfil. O painel saiu daqui.
//
// AQUI HAVIA O BLOCO "Complete seu perfil e ganhe coins", com a lista dos dados
// que faltavam e o preço de cada um. Ele foi removido em 04/09/2026, e o motivo
// é de leitura, não de espaço: a lista ficava LONGE dos campos. A pessoa lia
// "faltam 10 coins", descia até o formulário e não sabia qual campo pagava — o
// preço estava num lugar e a ação em outro.
//
// O preço passou a morar NA LINHA DO CAMPO: o "+N" amarelo à direita do rótulo
// (`BonusCoins`, em components/ui/Formulario.js, alimentado pelo hook
// useCoinsPerfil), que fica riscado em cinza quando o servidor confirma que
// pagou. O risco é o recibo.
//
// O QUE SOBROU AQUI, e por que o arquivo não virou um apagado: DUAS REGRAS que
// o "+10" sozinho não consegue dizer e que, caladas, viram reclamação:
//
//  1. É UMA VEZ POR DADO. Apagar e preencher de novo não paga outra vez (a
//     trava é o índice único do extrato de coins, no banco). Sem avisar, isso
//     vira "o site me roubou 10 coins".
//  2. O ENDEREÇO CONTA COMO UM DADO, não como sete. Pagar por campo faria o
//     endereço valer 70 coins e viraria o caminho mais barato de imprimir
//     dinheiro no site.
//
// Isso é rodapé, não painel: uma linha discreta no fim da aba de dados.
import React from "react";
import { coinsEmReaisTexto } from "../../../config/coins";

// O total vem por PROP, e não de um fetch próprio: a aba que monta este rodapé
// já tem o hook useCoinsPerfil carregado. Buscar de novo a mesma resposta é a
// forma mais fácil de a tela passar a exibir dois totais diferentes por meio
// segundo.
const RegrasCoinsPerfil = ({ aGanhar = 0 }) => {
  // Quem já recebeu tudo não tem regra a aprender: sem nada a ganhar, o rodapé
  // seria ruído permanente numa tela que se visita para editar o nome.
  if (!aGanhar) return null;

  return (
    <p className="text-xs text-white/40 leading-relaxed">
      <i className="bi bi-coin text-insigne-bonus mr-1.5" aria-hidden="true" />
      O número amarelo ao lado de um campo é o que ele ainda rende, e o riscado
      em cinza é o que você já recebeu: faltam{" "}
      <strong className="text-insigne-bonus">{aGanhar} Insigne Coins</strong>{" "}
      (R$ {coinsEmReaisTexto(aGanhar)}), que valem desconto em e-books e no Clube
      Insigne. Cada dado paga uma vez só (apagar e preencher de novo não paga de
      novo), e o endereço, na aba Endereços de Entrega, conta como um dado só e
      só rende completo.
    </p>
  );
};

export default RegrasCoinsPerfil;
